<template>
  <inline-svg
    :class="['svg', gaEventClass]"
    :src="`https://globalstatic.xangle.io/svg/${icon}.svg`"
    :width="size"
    :height="size"
    :fill="bcColor"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import InlineSvg from 'vue-inline-svg'

import { getGAEventName } from '../../utils/ga.util.ts'
import { IBcIconProps } from './icon.types.ts'

const props = withDefaults(defineProps<IBcIconProps>(), {
  size: 24,
  opacity: 1
})

const bcColor = computed(()=>{
  if (!props.color) return 'inherit'
  return `rgba(var(--bc-${props.color}),${props.opacity})`
})

const gaEventClass = computed(()=>{
  return getGAEventName(props.gaEventName)
})

</script>

<style lang="scss">
@import './xangle-icon.css';

.svg path {
  fill: v-bind(bcColor);
}
.svg rect {
  fill: v-bind(bcColor);
}

</style>